import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-40c8bddc"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "flex items-center text-black text-lg" };
var _hoisted_2 = { for: "date" };
var _hoisted_3 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_4 = { style: { "margin=top": "2%" } };
var _hoisted_5 = { for: "confidentiality" };
var _hoisted_6 = { value: "foto" };
var _hoisted_7 = { value: "Video" };
var _hoisted_8 = { value: "registrazione" };
var _hoisted_9 = { value: "esamistrumentali" };
var _hoisted_10 = { value: "dicom" };
var _hoisted_11 = { value: "documento" };
var _hoisted_12 = { value: "kardia" };
var _hoisted_13 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_14 = { style: { "margin=top": "2%" } };
var _hoisted_15 = { style: { "margin-top": "2%" } };
var _hoisted_16 = {
    key: 0,
    for: "confidenzialità"
};
var _hoisted_17 = ["value"];
var _hoisted_18 = { class: "text-red-500 mb-2 w-full" };
var _hoisted_19 = {
    key: 0,
    style: { "margin-top": "2%" }
};
var _hoisted_20 = { class: "tags" };
var _hoisted_21 = { style: { "display": "inline-block" } };
var _hoisted_22 = ["checked", "onChange"];
var _hoisted_23 = { style: { "display": "inline-block" } };
var _hoisted_24 = { class: "flex justify-between" };
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { ref, computed } from "vue";
import { Modal } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'modal_editfile',
    props: {
        type: {}
    },
    setup: function (__props, _a) {
        var __expose = _a.expose;
        var props = __props;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var errors = ref([]);
        var alertConfirmMessage = ref(null);
        var loading = ref(false);
        // Resolve promise function
        var resolvePromise;
        var modalType = ref("confirm");
        var trueBtnText = computed(function () {
            return modalType.value === "confirm" ? "Yes" : "Okay";
        });
        var falseBtnText = ref("No");
        var showConfirm = ref(false);
        var row = ref({});
        function openModal(message, alertModal, rowData) {
            row.value = rowData;
            console.log(rowData);
            alertConfirmMessage.value = message;
            alertModal ? (modalType.value = "alert") : (modalType.value = "confirm");
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function handleUserInput(value) {
            if (!resolvePromise)
                return;
            resolvePromise(value);
            showConfirm.value = false;
        }
        function checkAll($event) {
            if ($event.target.checked) {
                row.value.tags = tagsToArray();
            }
            else {
                row.value.tags = [];
            }
        }
        function checkTag($event, tag) {
            var tagArray = [];
            if (row.value.tags.length != 0) {
                tagArray = row.value.tags;
            }
            if ($event.target.checked) {
                tagArray = tagArray.concat(tag.id);
            }
            else {
                tagArray = tagArray.filter(function (taga) { return taga != tag.id; });
            }
            row.value.tags = tagArray;
            console.log(tagArray);
        }
        function tagsToArray() {
            var tagsArray = [];
            var i = 0;
            for (var _i = 0, _a = patient.value.tag_medical_specialties; _i < _a.length; _i++) {
                var tag = _a[_i];
                tagsArray[i++] = tag.id;
            }
            console.log(tagsArray);
            return tagsArray;
        }
        var errorInvalidDate = ref('');
        function validateDate() {
            var selectedDate = new Date(row.value.data_rilievo);
            var today = new Date();
            if (selectedDate > today) {
                errorInvalidDate.value = 'La data di inserimento non può essere successiva alla data odierna';
                row.value.data_rilievo = today;
            }
            else {
                errorInvalidDate.value = '';
            }
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    size: "2xl",
                    onClose: _cache[7] || (_cache[7] = function ($event) { return (handleUserInput(false)); })
                }, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(alertConfirmMessage.value)), 1)
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("Data rilievo")), 1),
                        _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_unref(row).data_rilievo) = $event); }),
                            onChange: validateDate,
                            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        }, null, 544), [
                            [_vModelText, _unref(row).data_rilievo]
                        ]),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(errorInvalidDate)), 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("file tipo")), 1),
                            _withDirectives(_createElementVNode("select", {
                                name: "doctype",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((_unref(row).type) = $event); }),
                                class: _normalizeClass([{ 'border-red-500': _unref(errors)[0] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"])
                            }, [
                                _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("Foto")), 1),
                                _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("Video")), 1),
                                _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("Registrazione")), 1),
                                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t("Video Esami Strumentali")), 1),
                                _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t("Immagine Dicom")), 1),
                                _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("Documento")), 1),
                                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t("Kardia")), 1)
                            ], 2), [
                                [_vModelSelect, _unref(row).type]
                            ]),
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(errors)[0]), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.$t("Note")), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((_unref(row).file_commento) = $event); }),
                                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            }, null, 512), [
                                [_vModelText, _unref(row).file_commento]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            (_unref(row).id_file == null)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_16, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1))
                                : _createCommentVNode("", true),
                            (_unref(row).id_file == null)
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 1,
                                    id: "confidenzialità",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((_unref(row).id_livello_confidenzialita) = $event); }),
                                    class: _normalizeClass([{ 'border-red-500': _unref(errors)[1] }, "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"])
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, function (item, key) {
                                        return (_openBlock(), _createElementBlock("option", {
                                            value: item.id_livello_confidenzialita,
                                            key: key
                                        }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_17));
                                    }), 128))
                                ], 2)), [
                                    [_vModelSelect, _unref(row).id_livello_confidenzialita]
                                ])
                                : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(errors)[1]), 1)
                        ]),
                        (_unref(row).tags != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t("tagLabel")), 1),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("input", {
                                        ref: "allCheck",
                                        type: "checkbox",
                                        style: { "display": "inline-block", "margin-right": "5%", "margin-left": "5%" },
                                        onChange: _cache[4] || (_cache[4] = function ($event) { return (checkAll($event)); })
                                    }, null, 544),
                                    _createElementVNode("h1", _hoisted_21, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("allSelect")), 1)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).tag_medical_specialties, function (tag) {
                                        return (_openBlock(), _createElementBlock("div", {
                                            style: { "margin-left": "5%" },
                                            key: tag.id
                                        }, [
                                            _createElementVNode("input", {
                                                ref_for: true,
                                                ref: 'tag' + tag.id,
                                                type: "checkbox",
                                                checked: _unref(row).tags.includes(tag.id),
                                                style: { "display": "inline-block", "margin-right": "5%" },
                                                onChange: function ($event) { return (checkTag($event, tag)); }
                                            }, null, 40, _hoisted_22),
                                            _createElementVNode("p", _hoisted_23, _toDisplayString(tag.tag), 1)
                                        ]));
                                    }), 128))
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("button", {
                                onClick: _cache[5] || (_cache[5] = function ($event) { return (handleUserInput(false)); }),
                                type: "button",
                                class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                            }, _toDisplayString(_ctx.$t("Annulla")), 1),
                            _createElementVNode("button", {
                                onClick: _cache[6] || (_cache[6] = function ($event) { return (handleUserInput(true)); }),
                                type: "button",
                                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, _toDisplayString(_ctx.$t("Invia")), 1)
                        ])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
